import type { TGlobalState } from '@/types/state-types'
import { DEFAULT_PAGE_LIMIT } from '@/utils/constants'

export default <TGlobalState>{
  loader: true,
  errors: null,
  abortControllers: null,
  abortControllersWithFilters: null,
  toastNotifications: null,
  refreshAttempts: 0,
  isAttemptingRefresh: false,
  renewRequestPromise: null,
  userId: null,
  accessToken: null,
  breadcrumbs: [],
  officerWorker: null,
  geofenceWorker: null,
  progressLoader: false,
  validationConfig: null,
  formAutomatedResponseFields: null,
  showBulkOperationErrors: false,
  bulkOperationErrors: null,
  bulkOperationSuccessMessage: null,
  bulkOperationFailedMessage: null,
  polygonsLoadedCount: null,
  showAuthorizedPatrols: false,
  showNotifications: false,
  hasBreadcrumbs: false,
  hasNewNotifications: false,
  customPageLimit: DEFAULT_PAGE_LIMIT,
  isNavbarCollapsed: false
}
